(function () {
  'use strict';

  if (window.CraftTiTest) {
    window.CraftTiTest.refresh();
    return;
  }

  var controllers = new WeakMap();

  function asArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function getRoots() {
    return asArray(document.querySelectorAll('[data-cti-test]'));
  }

  function syncPageClass(excludedRoot) {
    if (!document.body) return;

    var shouldHideThemeChrome = getRoots().some(function (root) {
      return root !== excludedRoot && root.dataset.ctiHideThemeChrome === 'true';
    });

    document.body.classList.toggle('cti-test-page', shouldHideThemeChrome);
  }

  function initCraftTiTest(root) {
    if (!root || controllers.has(root)) return;

    var quizData = window.CraftTiQuizData;
    if (
      !quizData ||
      !quizData.questions ||
      !quizData.questions.length ||
      !quizData.personalities
    ) {
      return;
    }

    var cleanups = [];
    var timeouts = new Set();
    var steps = asArray(root.querySelectorAll('[data-cti-step]'));
    var mailboxStage = root.querySelector('[data-cti-mailbox-stage]');
    var letterTrigger = root.querySelector('[data-cti-open-letter]');
    var startTrigger = root.querySelector('[data-cti-start]');
    var lampStage = root.querySelector('[data-cti-lamp-stage]');
    var gateButton = root.querySelector('[data-cti-open-gate]');
    var letterCopy = root.querySelector('[data-cti-letter-copy]');
    var letterScrollbar = root.querySelector('[data-cti-letter-scrollbar]');
    var letterScrollbarThumb = root.querySelector(
      '[data-cti-letter-scrollbar-thumb]'
    );
    var quizStage = root.querySelector('[data-cti-quiz-stage]');
    var questionPanel = root.querySelector('[data-cti-question-panel]');
    var questionTitle = root.querySelector('[data-cti-question-title]');
    var questionProgress = root.querySelector('[data-cti-question-progress]');
    var questionStory = root.querySelector('[data-cti-question-story]');
    var questionPrompt = root.querySelector('[data-cti-question-prompt]');
    var selectionNote = root.querySelector('[data-cti-selection-note]');
    var choicesScroll = root.querySelector('[data-cti-choices-scroll]');
    var choicesContainer = root.querySelector('[data-cti-choices]');
    var selectionError = root.querySelector('[data-cti-selection-error]');
    var previousButton = root.querySelector('[data-cti-previous-question]');
    var nextButton = root.querySelector('[data-cti-next-question]');
    var resultScene = root.querySelector('.result-scene');
    var resultScroll = root.querySelector('[data-cti-result-scroll]');
    var resultName = root.querySelector('[data-cti-result-name]');
    var resultCore = root.querySelector('[data-cti-result-core]');
    var resultHidden = root.querySelector('[data-cti-result-hidden]');
    var resultTags = asArray(root.querySelectorAll('[data-cti-result-tag]'));
    var resultImageNodes = asArray(
      root.querySelectorAll('[data-cti-result-image]')
    );
    var hiddenImageNodes = asArray(
      root.querySelectorAll('[data-cti-hidden-image]')
    );
    var hiddenMatchCard = root.querySelector('[data-cti-hidden-card]');
    var hiddenMatchName = root.querySelector('[data-cti-hidden-match-name]');
    var hiddenMatchTags = asArray(
      root.querySelectorAll('[data-cti-hidden-tag]')
    );
    var resultAssetsScript = root.querySelector('[data-cti-result-assets]');
    var resultAssets = {};
    var shareButton = root.querySelector('[data-cti-open-share]');
    var saveButton = root.querySelector('[data-cti-open-save]');
    var newTestButton = root.querySelector('[data-cti-new-test]');
    var modalLayer = root.querySelector('[data-cti-result-modal-layer]');
    var copyLinkButton = root.querySelector('[data-cti-copy-link]');
    var copyField = root.querySelector('[data-cti-copy-field]');
    var copyUrl = root.querySelector('[data-cti-copy-url]');
    var copyFeedback = root.querySelector('[data-cti-copy-feedback]');
    var shareFeedback = root.querySelector('[data-cti-share-feedback]');
    var communityShareLink = root.querySelector('[data-cti-community-share]');
    var socialShareLinks = asArray(
      root.querySelectorAll('[data-cti-share-link]')
    );
    var instagramShareButton = root.querySelector(
      '[data-cti-share-channel="instagram"]'
    );
    var facebookShareLink = root.querySelector(
      '[data-cti-share-channel="facebook"]'
    );
    var xShareLink = root.querySelector('[data-cti-share-channel="x"]');
    var pinterestShareLink = root.querySelector(
      '[data-cti-share-channel="pinterest"]'
    );
    var redditShareLink = root.querySelector(
      '[data-cti-share-channel="reddit"]'
    );
    var moreShareButton = root.querySelector(
      '[data-cti-share-channel="more"]'
    );
    var saveEmailForm = root.querySelector('.save-form');
    var saveEmailButton = root.querySelector('[data-cti-save-email]');
    var saveEmailButtonLabel = root.querySelector('[data-cti-save-email-label]');
    var saveEmailInput = root.querySelector('[data-cti-save-email-input]');
    var saveEmailTags = root.querySelector('[data-cti-save-email-tags]');
    var saveEmailHeading = root.querySelector('[data-cti-save-email-heading]');
    var saveEmailIntro = root.querySelector('[data-cti-save-email-intro]');
    var saveEmailSuccess = root.querySelector('[data-cti-save-email-success]');
    var saveEmailError = root.querySelector('[data-cti-save-email-error]');
    var saveEmailPostedSuccessfully =
      root.dataset.ctiSavePostedSuccessfully === 'true';
    var saveEmailHasErrors = root.dataset.ctiSaveHasErrors === 'true';
    var saveEmailServerStateRestored = false;
    var saveEmailReturnTo = saveEmailForm
      ? saveEmailForm.querySelector('input[name="return_to"]')
      : null;
    var liveRegion = root.querySelector('[data-cti-live]');
    var communityBaseUrl =
      String(root.dataset.ctiCommunityUrl || '').trim() ||
      'https://community.robotime.com/';
    var resultPaperMobileUrl = String(
      root.dataset.ctiResultPaperMobile || ''
    ).trim();
    var analyticsVersion = '1.0.0';
    var quizVersion = '2026-08-06';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var currentStep = 1;
    var currentQuestionIndex = 0;
    var answers = {};
    var transitioning = false;
    var lastModalTrigger = null;
    var lastResult = null;
    var resultEmailEligible = true;
    var activeResultDialog = null;
    var modalFocusFrameId = null;
    var copyFeedbackTimeoutId = null;
    var resultLoadToken = 0;
    var shareImageFile = null;
    var shareImagePromise = null;
    var shareImageResultKey = '';
    var anonymousId = '';
    var quizRunId = createAnalyticsId('run');
    var quizStartedAt = 0;
    var analyticsSequence = 0;
    var trackedAnswerSignatures = {};
    var completionTracked = false;
    var entryMode = 'quiz';
    var fixedHiddenPersonalityIds = {
      curator: 'virtuoso',
      virtuoso: 'curator',
      stylist: 'storyteller',
      storyteller: 'stylist',
      'time-sculptor': 'whatever',
      whatever: 'time-sculptor',
    };

    function createAnalyticsId(prefix) {
      var id = '';

      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        id = window.crypto.randomUUID();
      } else {
        id =
          Date.now().toString(36) +
          '-' +
          Math.random().toString(36).slice(2, 12);
      }

      return (prefix ? prefix + '-' : '') + id;
    }

    function analyticsAllowed() {
      var customerPrivacy =
        window.Shopify && window.Shopify.customerPrivacy
          ? window.Shopify.customerPrivacy
          : null;

      if (
        !customerPrivacy ||
        typeof customerPrivacy.analyticsProcessingAllowed !== 'function'
      ) {
        return true;
      }

      try {
        return customerPrivacy.analyticsProcessingAllowed();
      } catch (error) {
        return false;
      }
    }

    function getAnonymousId() {
      if (anonymousId) return anonymousId;

      var storageKey = 'craft_ti_anonymous_id';
      try {
        anonymousId = window.localStorage.getItem(storageKey) || '';
        if (!anonymousId) {
          anonymousId = createAnalyticsId('visitor');
          window.localStorage.setItem(storageKey, anonymousId);
        }
      } catch (error) {
        anonymousId = createAnalyticsId('visitor');
      }

      return anonymousId;
    }

    function getDeviceType() {
      if (window.matchMedia('(max-width: 767px)').matches) return 'mobile';
      if (window.matchMedia('(max-width: 1024px)').matches) return 'tablet';
      return 'desktop';
    }

    function getSafeReferrerPath() {
      if (!document.referrer) return '';

      try {
        var referrerUrl = new URL(document.referrer);
        return referrerUrl.origin + referrerUrl.pathname;
      } catch (error) {
        return '';
      }
    }

    function getAttributionData() {
      var pageUrl = new URL(window.location.href);
      var parameters = pageUrl.searchParams;

      return {
        page_path: pageUrl.pathname,
        referrer_path: getSafeReferrerPath(),
        utm_source: String(parameters.get('utm_source') || '').slice(0, 100),
        utm_medium: String(parameters.get('utm_medium') || '').slice(0, 100),
        utm_campaign: String(parameters.get('utm_campaign') || '').slice(0, 100),
        utm_content: String(parameters.get('utm_content') || '').slice(0, 100),
        utm_term: String(parameters.get('utm_term') || '').slice(0, 100),
      };
    }

    function getResultAnalyticsData(result) {
      var activeResult = result || lastResult;
      if (!activeResult) return {};

      var resultData = {
        core_type: activeResult.coreId || '',
        hidden_type: activeResult.hiddenId || '',
      };

      Object.keys(activeResult.scores || {}).forEach(function (personalityId) {
        resultData['score_' + personalityId.replace(/-/g, '_')] =
          activeResult.scores[personalityId];
      });

      return resultData;
    }

    function trackAnalytics(eventName, details) {
      if (!analyticsAllowed()) return false;

      analyticsSequence += 1;
      var eventData = Object.assign(
        {
          event_id: createAnalyticsId('event'),
          anonymous_id: getAnonymousId(),
          quiz_run_id: quizRunId,
          analytics_version: analyticsVersion,
          quiz_version: quizVersion,
          event_sequence: analyticsSequence,
          occurred_at: new Date().toISOString(),
          entry_mode: entryMode,
          section_id: root.dataset.ctiSectionId || '',
          locale: document.documentElement.lang || navigator.language || '',
          device_type: getDeviceType(),
        },
        getAttributionData(),
        details || {}
      );
      var dataLayerEvent = Object.assign({ event: eventName }, eventData);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerEvent);

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        try {
          var published = window.Shopify.analytics.publish(
            eventName.replace(/^craft_ti_/, 'craft_ti:'),
            eventData
          );
          if (published && typeof published.catch === 'function') {
            published.catch(function () {});
          }
        } catch (error) {}
      }

      try {
        root.dispatchEvent(
          new CustomEvent('craft-ti:analytics-event', {
            bubbles: true,
            detail: dataLayerEvent,
          })
        );
      } catch (error) {}

      return true;
    }

    function trackQuestionAnswer(question) {
      if (!question) return;

      var selectedIds = getSelectedIds(question);
      var signature = selectedIds.slice().sort().join('|');
      if (trackedAnswerSignatures[question.id] === signature) return;

      trackedAnswerSignatures[question.id] = signature;
      trackAnalytics('craft_ti_question_answered', {
        question_id: question.id,
        question_number: currentQuestionIndex + 1,
        question_count: quizData.questions.length,
        question_mode: question.mode || 'single',
        answer_ids: selectedIds,
        answer_ids_csv: selectedIds.join(','),
        answer_count: selectedIds.length,
      });
    }

    function getFixedHiddenPersonalityId(coreId) {
      var hiddenId = fixedHiddenPersonalityIds[coreId];
      return hiddenId &&
        Object.prototype.hasOwnProperty.call(quizData.personalities, hiddenId)
        ? hiddenId
        : '';
    }

    if (resultAssetsScript) {
      try {
        resultAssets = JSON.parse(resultAssetsScript.textContent || '{}');
      } catch (error) {
        resultAssets = {};
      }
    }

    if (
      !steps.length ||
      !mailboxStage ||
      !letterTrigger ||
      !startTrigger ||
      !lampStage ||
      !gateButton ||
      !quizStage ||
      !questionPanel ||
      !questionTitle ||
      !questionProgress ||
      !questionStory ||
      !questionPrompt ||
      !selectionNote ||
      !choicesScroll ||
      !choicesContainer ||
      !selectionError ||
      !previousButton ||
      !nextButton ||
      !resultScene ||
      !resultName ||
      !resultCore ||
      !resultHidden
    ) {
      return;
    }

    function listen(target, type, handler, options) {
      if (!target || !target.addEventListener) return;
      target.addEventListener(type, handler, options);
      cleanups.push(function () {
        target.removeEventListener(type, handler, options);
      });
    }

    function addTimeout(callback, delay) {
      var timeoutId = window.setTimeout(function () {
        timeouts.delete(timeoutId);
        callback();
      }, delay);
      timeouts.add(timeoutId);
      return timeoutId;
    }

    function announce(message) {
      if (!liveRegion) return;
      liveRegion.textContent = '';
      addTimeout(function () {
        liveRegion.textContent = message;
      }, 30);
    }

    function preloadStep(stepNumber) {
      var step = root.querySelector('[data-cti-step="' + stepNumber + '"]');
      if (!step) return;

      asArray(step.querySelectorAll('img')).forEach(function (image) {
        var source = image.currentSrc || image.src;
        if (!source) return;
        var preload = new Image();
        preload.decoding = 'async';
        preload.src = source;
        if (preload.decode) preload.decode().catch(function () {});
      });
    }

    function syncLetterScrollbar() {
      if (!letterCopy || !letterScrollbar || !letterScrollbarThumb) return;

      var contentHeight = Math.max(letterCopy.scrollHeight, 1);
      var viewportHeight = letterCopy.clientHeight;
      var trackHeight = letterScrollbar.clientHeight;
      var maxScroll = Math.max(contentHeight - viewportHeight, 0);
      var minimumThumbHeight = Math.min(48, trackHeight);
      var thumbHeight = Math.min(
        trackHeight,
        Math.max(trackHeight * (viewportHeight / contentHeight), minimumThumbHeight)
      );
      var thumbTop = maxScroll
        ? (letterCopy.scrollTop / maxScroll) * (trackHeight - thumbHeight)
        : 0;

      letterScrollbarThumb.style.height = String(thumbHeight) + 'px';
      letterScrollbarThumb.style.transform =
        'translateY(' + String(thumbTop) + 'px)';
    }

    function showStep(stepNumber, animate) {
      if (
        currentStep === stepNumber &&
        !root.querySelector('[data-cti-step="' + stepNumber + '"][hidden]')
      ) {
        return;
      }

      steps.forEach(function (step) {
        var isActive = Number(step.dataset.ctiStep) === stepNumber;
        step.hidden = !isActive;
        step.setAttribute('aria-hidden', String(!isActive));
        step.classList.remove('cti-is-entering');

        if (isActive && animate !== false && !reducedMotion.matches) {
          window.requestAnimationFrame(function () {
            step.classList.add('cti-is-entering');
          });
          addTimeout(function () {
            step.classList.remove('cti-is-entering');
          }, 240);
        }
      });

      currentStep = stepNumber;
      root.dataset.ctiCurrentStep = String(stepNumber);
      preloadStep(Math.min(stepNumber + 1, 3));

      if (stepNumber === 2 && letterCopy) {
        letterCopy.scrollTop = 0;
        window.requestAnimationFrame(syncLetterScrollbar);
      }

      if (stepNumber === 3) {
        quizStage.classList.remove('quiz-live');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            quizStage.classList.add('quiz-live');
          });
        });
      }
    }

    function markLetterReady() {
      if (
        mailboxStage.classList.contains('is-letter-ready') ||
        mailboxStage.classList.contains('is-letter-open')
      ) {
        return;
      }

      mailboxStage.classList.add('is-letter-ready');
      announce('The letter is ready to open.');
    }

    function openLetter() {
      if (transitioning || mailboxStage.classList.contains('is-letter-open')) return;

      markLetterReady();
      transitioning = true;
      mailboxStage.classList.add('is-letter-open');
      addTimeout(function () {
        showStep(2, true);
        transitioning = false;
        announce('A mysterious room appears. Open the gate to continue.');
      }, reducedMotion.matches ? 20 : 980);
    }

    listen(letterTrigger, 'animationend', function (event) {
      if (
        event.target === letterTrigger &&
        event.animationName === 'cti-s1-letterWithMailboxIn'
      ) {
        markLetterReady();
      }
    });

    listen(startTrigger, 'click', openLetter);

    function openGate(event) {
      event.preventDefault();
      if (transitioning || lampStage.classList.contains('is-lamp-open')) return;

      transitioning = true;
      lampStage.classList.add('is-lamp-open');
      quizStartedAt = Date.now();
      trackAnalytics('craft_ti_started', {
        question_count: quizData.questions.length,
      });
      addTimeout(function () {
        showStep(3, false);
        transitioning = false;
        announce('Question 1 of 9. Choose the treasure you would seek first.');
      }, reducedMotion.matches ? 20 : 760);
    }

    listen(gateButton, 'click', openGate);
    listen(letterCopy, 'scroll', syncLetterScrollbar, { passive: true });
    listen(window, 'resize', syncLetterScrollbar);

    function getCurrentQuestion() {
      return quizData.questions[currentQuestionIndex];
    }

    function getSelectedIds(question) {
      return answers[question.id] ? answers[question.id].slice() : [];
    }

    function getOption(question, optionId) {
      return question.options.find(function (option) {
        return option.id === optionId;
      });
    }

    function isQuestionComplete(question) {
      return getSelectedIds(question).length > 0;
    }

    function createChoice(question, option, selected, index) {
      var choice = document.createElement('button');
      choice.className = 'choice';
      choice.type = 'button';
      choice.dataset.ctiOption = option.id;
      choice.setAttribute('aria-pressed', String(selected));
      choice.style.setProperty('--choice-index', String(index));
      if (selected) choice.classList.add('selected');

      var marker = document.createElement('span');
      marker.className = 'radio';
      marker.setAttribute('aria-hidden', 'true');

      var copy = document.createElement('span');
      if (option.group && question.mode !== 'grouped-multiple') {
        var group = document.createElement('em');
        group.className = 'choice-group';
        group.textContent = option.group;
        copy.appendChild(group);
      }

      var title = document.createElement('strong');
      title.textContent = option.title;
      copy.appendChild(title);

      if (option.description) {
        var description = document.createElement('small');
        description.textContent = option.description;
        copy.appendChild(description);
      }

      choice.appendChild(marker);
      choice.appendChild(copy);
      return choice;
    }

    function createChoiceType(question, groupName, options, selectedIds, startIndex) {
      var section = document.createElement('section');
      section.className = 'choice-type';

      var title = document.createElement('h3');
      title.className = 'choice-type-title';
      title.id =
        (root.id || 'craft-ti') +
        '-choice-type-' +
        String(currentQuestionIndex + 1) +
        '-' +
        String(startIndex + 1);

      var label = document.createElement('span');
      label.textContent = groupName;

      var instruction = document.createElement('small');
      instruction.textContent =
        '(' + (question.groupSelectionNote || 'Choose up to one') + ')';

      title.appendChild(label);
      title.appendChild(instruction);

      var optionRow = document.createElement('div');
      optionRow.className = 'choice-type-options';
      optionRow.setAttribute('role', 'group');
      optionRow.setAttribute('aria-labelledby', title.id);

      options.forEach(function (option, optionIndex) {
        optionRow.appendChild(
          createChoice(
            question,
            option,
            selectedIds.indexOf(option.id) !== -1,
            startIndex + optionIndex
          )
        );
      });

      section.appendChild(title);
      section.appendChild(optionRow);
      return section;
    }

    function updateQuestionControls(question) {
      var complete = isQuestionComplete(question);
      previousButton.disabled = currentQuestionIndex === 0;
      previousButton.setAttribute('aria-hidden', String(currentQuestionIndex === 0));
      nextButton.disabled = !complete;
      nextButton.textContent =
        currentQuestionIndex === quizData.questions.length - 1 ? 'See My Result' : 'Next';
    }

    function updateChoiceStates(question) {
      var selectedIds = getSelectedIds(question);
      asArray(choicesContainer.querySelectorAll('[data-cti-option]')).forEach(function (choice) {
        var selected = selectedIds.indexOf(choice.dataset.ctiOption) !== -1;
        choice.classList.toggle('selected', selected);
        choice.setAttribute('aria-pressed', String(selected));
      });
      updateQuestionControls(question);
    }

    function renderQuestion(shouldFocus) {
      var question = getCurrentQuestion();
      var selectedIds = getSelectedIds(question);

      root.dataset.ctiQuestion = question.id;
      quizStage.dataset.ctiQuestion = question.id;
      questionTitle.textContent = question.title;
      questionProgress.textContent =
        String(currentQuestionIndex + 1) + '/' + String(quizData.questions.length);
      questionStory.textContent = question.story;
      questionPrompt.textContent = question.prompt;
      var selectionInstruction =
        question.mode === 'single' || question.mode === 'grouped-multiple'
          ? ''
          : question.selectionNote || 'Select all that apply.';
      selectionInstruction = String(selectionInstruction).trim();
      selectionNote.hidden = !selectionInstruction;
      if (!selectionInstruction) {
        selectionNote.textContent = '';
      } else {
        selectionNote.textContent =
          selectionInstruction.charAt(0) === '(' &&
          selectionInstruction.charAt(selectionInstruction.length - 1) === ')'
            ? selectionInstruction
            : '(' + selectionInstruction + ')';
      }
      choicesContainer.setAttribute('aria-label', question.prompt);
      choicesContainer.replaceChildren();
      choicesContainer.dataset.choiceLayout =
        question.mode === 'grouped-multiple' ? 'grouped' : 'standard';

      if (question.mode === 'grouped-multiple') {
        var optionGroups = [];
        question.options.forEach(function (option) {
          var existingGroup = optionGroups.find(function (group) {
            return group.name === option.group;
          });
          if (!existingGroup) {
            existingGroup = { name: option.group || 'Options', options: [] };
            optionGroups.push(existingGroup);
          }
          existingGroup.options.push(option);
        });

        var renderedOptionCount = 0;
        optionGroups.forEach(function (group) {
          choicesContainer.appendChild(
            createChoiceType(
              question,
              group.name,
              group.options,
              selectedIds,
              renderedOptionCount
            )
          );
          renderedOptionCount += group.options.length;
        });
      } else {
        question.options.forEach(function (option, index) {
          choicesContainer.appendChild(
            createChoice(
              question,
              option,
              selectedIds.indexOf(option.id) !== -1,
              index
            )
          );
        });
      }

      choicesContainer.dataset.choiceCount = String(question.options.length);
      choicesScroll.scrollTop = 0;
      selectionError.hidden = true;
      updateQuestionControls(question);

      questionPanel.classList.remove('question-refreshed');
      if (currentStep === 3 && quizStage.classList.contains('quiz-live')) {
        window.requestAnimationFrame(function () {
          questionPanel.classList.add('question-refreshed');
        });
      }

      if (shouldFocus) {
        addTimeout(function () {
          questionStory.focus({ preventScroll: true });
        }, reducedMotion.matches ? 20 : 180);
      }
    }

    function selectAnswer(question, optionId) {
      var option = getOption(question, optionId);
      if (!option) return;

      var selectedIds = getSelectedIds(question);
      var selectedIndex = selectedIds.indexOf(optionId);

      if (question.mode === 'grouped-multiple') {
        if (selectedIndex !== -1) {
          selectedIds.splice(selectedIndex, 1);
        } else {
          selectedIds = selectedIds.filter(function (selectedId) {
            var selectedOption = getOption(question, selectedId);
            return !selectedOption || selectedOption.group !== option.group;
          });
          selectedIds.push(optionId);
        }
      } else {
        selectedIds = [optionId];
      }

      answers[question.id] = selectedIds;
      selectionError.hidden = true;
      updateChoiceStates(question);
      announce(
        selectedIds.indexOf(optionId) === -1
          ? option.title + ' removed.'
          : option.title + ' selected.'
      );
    }

    listen(choicesContainer, 'click', function (event) {
      var choice = event.target.closest('[data-cti-option]');
      if (!choice || !choicesContainer.contains(choice)) return;
      event.preventDefault();
      selectAnswer(getCurrentQuestion(), choice.dataset.ctiOption);
    });

    listen(previousButton, 'click', function (event) {
      event.preventDefault();
      if (currentQuestionIndex === 0) return;
      currentQuestionIndex -= 1;
      renderQuestion(true);
      announce(
        'Question ' +
          String(currentQuestionIndex + 1) +
          ' of ' +
          String(quizData.questions.length) +
          '.'
      );
    });

    function getTieBreakerPersonalities() {
      return quizData.questions
        .filter(function (question) {
          return question.tieBreakerPriority;
        })
        .sort(function (left, right) {
          return left.tieBreakerPriority - right.tieBreakerPriority;
        })
        .map(function (question) {
          var selectedIds = getSelectedIds(question);
          var option = selectedIds.length ? getOption(question, selectedIds[0]) : null;
          return option ? option.main : null;
        })
        .filter(Boolean);
    }

    function calculateResult() {
      var scores = {};
      quizData.personalityOrder.forEach(function (personalityId) {
        scores[personalityId] = 0;
      });

      quizData.questions.forEach(function (question) {
        if (question.countsTowardResult === false) return;

        getSelectedIds(question).forEach(function (optionId) {
          var option = getOption(question, optionId);
          if (!option) return;

          if (option.main && Object.prototype.hasOwnProperty.call(scores, option.main)) {
            scores[option.main] += 2;
          }

          (option.auxiliary || []).forEach(function (personalityId) {
            if (Object.prototype.hasOwnProperty.call(scores, personalityId)) {
              scores[personalityId] += 1;
            }
          });
        });
      });

      var tieBreakers = getTieBreakerPersonalities();
      var rankedIds = quizData.personalityOrder.slice().sort(function (left, right) {
        var scoreDifference = scores[right] - scores[left];
        if (scoreDifference) return scoreDifference;

        var leftTieIndex = tieBreakers.indexOf(left);
        var rightTieIndex = tieBreakers.indexOf(right);
        var leftPriority =
          leftTieIndex === -1
            ? tieBreakers.length + quizData.personalityOrder.indexOf(left)
            : leftTieIndex;
        var rightPriority =
          rightTieIndex === -1
            ? tieBreakers.length + quizData.personalityOrder.indexOf(right)
            : rightTieIndex;
        return leftPriority - rightPriority;
      });

      var coreId = rankedIds[0];
      var hiddenId = getFixedHiddenPersonalityId(coreId);

      return {
        coreId: coreId,
        hiddenId: hiddenId,
        core: quizData.personalities[coreId],
        hidden: quizData.personalities[hiddenId],
        scores: scores,
        styleChoice: getSelectedIds(quizData.questions[0])[0] || null,
      };
    }

    function cssImageUrl(url) {
      return (
        'url("' +
        String(url || '')
          .replace(/\\/g, '\\\\')
          .replace(/"/g, '\\"') +
        '")'
      );
    }

    function setResultImage(name, url) {
      resultImageNodes.forEach(function (image) {
        if (image.dataset.ctiResultImage !== name) return;

        if (!url) {
          image.hidden = true;
          image.removeAttribute('src');
          return;
        }

        image.hidden = false;
        if (image.getAttribute('src') !== url) {
          image.setAttribute('src', url);
        }
      });
    }

    function setHiddenResultImage(name, url) {
      hiddenImageNodes.forEach(function (image) {
        if (image.dataset.ctiHiddenImage !== name) return;

        if (!url) {
          image.hidden = true;
          image.removeAttribute('src');
          return;
        }

        image.hidden = false;
        if (image.getAttribute('src') !== url) {
          image.setAttribute('src', url);
        }
      });
    }

    function preloadImage(url) {
      if (!url) return Promise.resolve();

      return new Promise(function (resolve) {
        var image = new Image();
        var settled = false;
        var timeoutId = window.setTimeout(finish, 1800);

        function finish() {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);
          image.onload = null;
          image.onerror = null;
          resolve();
        }

        image.onload = finish;
        image.onerror = finish;
        image.src = url;

        if (typeof image.decode === 'function') {
          image.decode().then(finish).catch(function () {});
        }
      });
    }

    function applyResultVisuals(result) {
      var coreAssets = resultAssets[result.coreId] || {};
      var hiddenAssets = resultAssets[result.hiddenId] || {};
      var props = Array.isArray(coreAssets.props) ? coreAssets.props : [];
      var hiddenProps = Array.isArray(hiddenAssets.props)
        ? hiddenAssets.props
        : [];
      var isMobileResult = window.matchMedia(
        '(max-width: 900px), (orientation: portrait) and (max-width: 1024px)'
      ).matches;

      if (coreAssets.backgroundDesktop) {
        resultScene.style.setProperty(
          '--cti-image-result-bg-desktop',
          cssImageUrl(coreAssets.backgroundDesktop)
        );
      }
      if (coreAssets.backgroundMobile) {
        resultScene.style.setProperty(
          '--cti-image-result-bg-mobile',
          cssImageUrl(coreAssets.backgroundMobile)
        );
      }
      if (coreAssets.modalBackground) {
        resultScene.style.setProperty(
          '--cti-image-result-modal-bg',
          cssImageUrl(coreAssets.modalBackground)
        );
      }
      if (hiddenAssets.modalBackground) {
        resultScene.style.setProperty(
          '--cti-image-hidden-match-bg',
          cssImageUrl(hiddenAssets.modalBackground)
        );
      } else {
        resultScene.style.removeProperty('--cti-image-hidden-match-bg');
      }

      setResultImage('character', coreAssets.character);
      setResultImage('portrait', coreAssets.portrait);
      setResultImage('prop-1', props[0]);
      setResultImage('prop-2', props[1]);
      setResultImage('avatar', coreAssets.avatar);
      setHiddenResultImage('avatar', hiddenAssets.avatar);
      setHiddenResultImage('prop-1', hiddenProps[0]);
      setHiddenResultImage('prop-2', hiddenProps[1]);

      if (resultScroll) resultScroll.scrollTop = 0;

      return Promise.all([
        preloadImage(
          isMobileResult
            ? coreAssets.backgroundMobile
            : coreAssets.backgroundDesktop
        ),
        preloadImage(coreAssets.character),
        preloadImage(coreAssets.portrait),
        preloadImage(props[0]),
        preloadImage(props[1]),
        preloadImage(coreAssets.modalBackground),
        preloadImage(coreAssets.avatar),
        preloadImage(hiddenAssets.modalBackground),
        preloadImage(hiddenAssets.avatar),
        preloadImage(hiddenProps[0]),
        preloadImage(hiddenProps[1]),
        preloadImage(isMobileResult ? resultPaperMobileUrl : ''),
      ]);
    }

    function renderResult(result) {
      lastResult = result;
      resultEmailEligible = result.emailEligible !== false;
      root.dataset.ctiResultType = result.coreId;
      if (result.hiddenId) {
        root.dataset.ctiHiddenType = result.hiddenId;
      } else {
        root.removeAttribute('data-cti-hidden-type');
      }
      resultScene.style.setProperty('--result-accent', result.core.accent);
      resultScene.style.setProperty('--result-backdrop', result.core.backdrop);
      resultScene.style.setProperty(
        '--hidden-result-accent',
        result.hidden.accent || result.core.accent
      );
      resultName.textContent = result.core.name;
      resultCore.textContent = result.core.core;
      resultHidden.textContent = result.hidden.hidden;
      if (hiddenMatchCard) hiddenMatchCard.hidden = !result.hiddenId;
      if (hiddenMatchName) hiddenMatchName.textContent = result.hidden.name;

      resultTags.forEach(function (tag, index) {
        tag.textContent = result.core.tags[index] || '';
      });
      hiddenMatchTags.forEach(function (tag, index) {
        tag.textContent = result.hidden.tags
          ? result.hidden.tags[index] || ''
          : '';
        tag.hidden = !tag.textContent;
      });

      syncCommunityShareLink();

      return applyResultVisuals(result);
    }

    function revealResult(loadToken, shouldFocusHeading) {
      if (loadToken !== resultLoadToken) return;

      quizStage.classList.remove('is-result-loading');
      quizStage.classList.add('show-result');
      nextButton.disabled = false;
      nextButton.removeAttribute('aria-busy');
      nextButton.textContent = 'Next';

      if (!shouldFocusHeading) return;

      var heading = root.querySelector('.result-heading');
      if (heading) {
        addTimeout(function () {
          heading.focus({ preventScroll: true });
        }, reducedMotion.matches ? 20 : 620);
      }
    }

    function showCalculatedResult() {
      var loadToken = ++resultLoadToken;
      var result = calculateResult();
      if (!completionTracked) {
        completionTracked = true;
        trackAnalytics(
          'craft_ti_completed',
          Object.assign(
            {
              question_count: quizData.questions.length,
              answered_question_count: Object.keys(answers).filter(function (
                questionId
              ) {
                return answers[questionId] && answers[questionId].length;
              }).length,
              completion_time_seconds: quizStartedAt
                ? Math.max(0, Math.round((Date.now() - quizStartedAt) / 1000))
                : null,
            },
            getResultAnalyticsData(result)
          )
        );
      }
      quizStage.classList.add('is-result-loading');
      nextButton.disabled = true;
      nextButton.setAttribute('aria-busy', 'true');
      nextButton.textContent = 'Loading...';

      renderResult(result).then(function () {
        revealResult(loadToken, true);
        announce(
          'Your CRAFT-TI core type is ' +
            result.core.name +
            '. Your hidden type is ' +
            result.hidden.name +
            '.'
        );
      });
    }

    listen(nextButton, 'click', function (event) {
      event.preventDefault();
      var question = getCurrentQuestion();

      if (!isQuestionComplete(question)) {
        selectionError.hidden = false;
        announce('Please choose an answer before continuing.');
        return;
      }

      trackQuestionAnswer(question);

      if (currentQuestionIndex === quizData.questions.length - 1) {
        showCalculatedResult();
        return;
      }

      currentQuestionIndex += 1;
      renderQuestion(true);
      announce(
        'Question ' +
          String(currentQuestionIndex + 1) +
          ' of ' +
          String(quizData.questions.length) +
          '.'
      );
    });

    function setShareFeedback(state, message) {
      if (!shareFeedback) {
        if (message) announce(message);
        return;
      }

      shareFeedback.textContent = message || '';
      if (state) {
        shareFeedback.dataset.state = state;
      } else {
        shareFeedback.removeAttribute('data-state');
      }
    }

    function setImageShareButtonsReady(isReady) {
      [instagramShareButton, moreShareButton].forEach(function (button) {
        if (!button) return;
        button.disabled = !isReady;
        if (isReady) {
          button.removeAttribute('aria-busy');
        } else {
          button.setAttribute('aria-busy', 'true');
        }
      });
    }

    function getShareCaption(resultUrl, separator) {
      var resultLabel = lastResult ? lastResult.core.name : 'CRAFT-TI';
      var paragraphSeparator =
        typeof separator === 'string' ? separator : ' ';
      return (
        'My Craft-TI type is ' +
        resultLabel +
        '.' +
        paragraphSeparator +
        "What's your crafting personality? Discover yours: " +
        resultUrl
      );
    }

    function getCommunityShareUrl() {
      var shareData = getShareData();
      var communityUrl;

      try {
        communityUrl = new URL('/new-topic', communityBaseUrl);
      } catch (error) {
        communityUrl = new URL(
          '/new-topic',
          'https://community.robotime.com/'
        );
      }

      var resultLabel = lastResult ? lastResult.core.name : 'CRAFT-TI';
      var coreAssets = lastResult ? resultAssets[lastResult.coreId] || {} : {};
      var communityImageUrl = String(coreAssets.communityImage || '').trim();
      var communityImageMarkdown = communityImageUrl
        ? '\n\n![My CRAFT-TI result: ' +
          resultLabel +
          '](' +
          communityImageUrl +
          ')'
        : '';
      var topicBody =
        'I just discovered my CRAFT-TI crafting personality ✨\n\n' +
        'My result is **' +
        resultLabel +
        '**.' +
        communityImageMarkdown +
        '\n\n' +
        'Curious what kind of crafter everyone else gets!\n\n' +
        'Find your type:\n' +
        shareData.url +
        '\n\nWhat did you get?';

      communityUrl.searchParams.set('body', topicBody);
      communityUrl.searchParams.set(
        'category',
        'cozy-talks-creative-ideas/rolife/33'
      );
      communityUrl.searchParams.set('tags', 'craft-ti-test');
      return communityUrl.toString();
    }

    function syncCommunityShareLink() {
      if (!communityShareLink || !lastResult) return;
      communityShareLink.setAttribute('href', getCommunityShareUrl());
    }

    function loadCanvasImage(url) {
      if (!url) return Promise.resolve(null);

      return new Promise(function (resolve) {
        var image = new Image();
        var settled = false;
        var timeoutId = window.setTimeout(function () {
          finish(null);
        }, 5000);

        function finish(value) {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeoutId);
          image.onload = null;
          image.onerror = null;
          resolve(value);
        }

        image.crossOrigin = 'anonymous';
        image.onload = function () {
          finish(image);
        };
        image.onerror = function () {
          finish(null);
        };
        image.src = url;
      });
    }

    function drawCover(context, image, x, y, width, height) {
      if (!image || !image.naturalWidth || !image.naturalHeight) return;

      var scale = Math.max(
        width / image.naturalWidth,
        height / image.naturalHeight
      );
      var drawWidth = image.naturalWidth * scale;
      var drawHeight = image.naturalHeight * scale;
      context.drawImage(
        image,
        x + (width - drawWidth) / 2,
        y + (height - drawHeight) / 2,
        drawWidth,
        drawHeight
      );
    }

    function drawContain(context, image, x, y, width, height) {
      if (!image || !image.naturalWidth || !image.naturalHeight) return;

      var scale = Math.min(
        width / image.naturalWidth,
        height / image.naturalHeight
      );
      var drawWidth = image.naturalWidth * scale;
      var drawHeight = image.naturalHeight * scale;
      context.drawImage(
        image,
        x + (width - drawWidth) / 2,
        y + height - drawHeight,
        drawWidth,
        drawHeight
      );
    }

    function getVisibleImageBounds(image) {
      var maxSampleSize = 384;
      var sampleScale = Math.min(
        1,
        maxSampleSize / Math.max(image.naturalWidth, image.naturalHeight)
      );
      var sampleWidth = Math.max(
        1,
        Math.round(image.naturalWidth * sampleScale)
      );
      var sampleHeight = Math.max(
        1,
        Math.round(image.naturalHeight * sampleScale)
      );
      var sampleCanvas = document.createElement('canvas');
      var sampleContext = sampleCanvas.getContext('2d');

      if (!sampleContext) return null;

      sampleCanvas.width = sampleWidth;
      sampleCanvas.height = sampleHeight;
      sampleContext.drawImage(image, 0, 0, sampleWidth, sampleHeight);

      try {
        var pixels = sampleContext.getImageData(
          0,
          0,
          sampleWidth,
          sampleHeight
        ).data;
        var minX = sampleWidth;
        var minY = sampleHeight;
        var maxX = -1;
        var maxY = -1;

        for (var y = 0; y < sampleHeight; y += 1) {
          for (var x = 0; x < sampleWidth; x += 1) {
            if (pixels[(y * sampleWidth + x) * 4 + 3] <= 8) continue;
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }

        if (maxX < minX || maxY < minY) return null;

        var padding = 2;
        minX = Math.max(0, minX - padding);
        minY = Math.max(0, minY - padding);
        maxX = Math.min(sampleWidth - 1, maxX + padding);
        maxY = Math.min(sampleHeight - 1, maxY + padding);

        return {
          x: (minX / sampleWidth) * image.naturalWidth,
          y: (minY / sampleHeight) * image.naturalHeight,
          width:
            ((maxX - minX + 1) / sampleWidth) * image.naturalWidth,
          height:
            ((maxY - minY + 1) / sampleHeight) * image.naturalHeight,
        };
      } catch (error) {
        return null;
      }
    }

    function drawVisibleContain(context, image, x, y, width, height) {
      if (!image || !image.naturalWidth || !image.naturalHeight) return;

      var bounds = getVisibleImageBounds(image) || {
        x: 0,
        y: 0,
        width: image.naturalWidth,
        height: image.naturalHeight,
      };
      var scale = Math.min(width / bounds.width, height / bounds.height);
      var drawWidth = bounds.width * scale;
      var drawHeight = bounds.height * scale;

      context.drawImage(
        image,
        bounds.x,
        bounds.y,
        bounds.width,
        bounds.height,
        x + width - drawWidth,
        y + height - drawHeight,
        drawWidth,
        drawHeight
      );
    }

    function roundedRectPath(context, x, y, width, height, radius) {
      var safeRadius = Math.min(radius, width / 2, height / 2);
      context.beginPath();
      context.moveTo(x + safeRadius, y);
      context.lineTo(x + width - safeRadius, y);
      context.quadraticCurveTo(x + width, y, x + width, y + safeRadius);
      context.lineTo(x + width, y + height - safeRadius);
      context.quadraticCurveTo(
        x + width,
        y + height,
        x + width - safeRadius,
        y + height
      );
      context.lineTo(x + safeRadius, y + height);
      context.quadraticCurveTo(x, y + height, x, y + height - safeRadius);
      context.lineTo(x, y + safeRadius);
      context.quadraticCurveTo(x, y, x + safeRadius, y);
      context.closePath();
    }

    function getWrappedLines(context, text, maxWidth, maxLines) {
      var words = String(text || '').trim().split(/\s+/);
      var lines = [];
      var currentLine = '';

      words.forEach(function (word) {
        var candidate = currentLine ? currentLine + ' ' + word : word;
        if (!currentLine || context.measureText(candidate).width <= maxWidth) {
          currentLine = candidate;
          return;
        }

        lines.push(currentLine);
        currentLine = word;
      });

      if (currentLine) lines.push(currentLine);
      if (lines.length <= maxLines) return lines;

      lines = lines.slice(0, maxLines);
      var finalLine = lines[maxLines - 1];
      while (
        finalLine.length > 1 &&
        context.measureText(finalLine + '…').width > maxWidth
      ) {
        finalLine = finalLine.slice(0, -1).trim();
      }
      lines[maxLines - 1] = finalLine + '…';
      return lines;
    }

    function setFittedCanvasFont(
      context,
      text,
      maxWidth,
      maxFontSize,
      minFontSize,
      fontTemplate
    ) {
      var fontSize = maxFontSize;

      while (fontSize > minFontSize) {
        context.font = fontTemplate.replace('{size}', String(fontSize));
        if (context.measureText(String(text || '')).width <= maxWidth) break;
        fontSize -= 2;
      }

      context.font = fontTemplate.replace('{size}', String(fontSize));
      return fontSize;
    }

    function drawFittedWrappedText(
      context,
      text,
      x,
      y,
      maxWidth,
      maxHeight,
      options
    ) {
      var settings = options || {};
      var maxFontSize = settings.maxFontSize || 30;
      var minFontSize = settings.minFontSize || 24;
      var lineHeightRatio = settings.lineHeightRatio || 1.35;
      var fontTemplate =
        settings.fontTemplate || '400 {size}px Poppins, Arial, sans-serif';
      var fontSize = maxFontSize;
      var lineHeight = Math.round(fontSize * lineHeightRatio);
      var lines = [];

      while (fontSize >= minFontSize) {
        context.font = fontTemplate.replace('{size}', String(fontSize));
        lineHeight = Math.round(fontSize * lineHeightRatio);
        lines = getWrappedLines(context, text, maxWidth, 999);
        if (lines.length * lineHeight <= maxHeight || fontSize === minFontSize) {
          break;
        }
        fontSize = Math.max(minFontSize, fontSize - 2);
      }

      var maxLines = Math.max(1, Math.floor(maxHeight / lineHeight));
      if (lines.length > maxLines) {
        lines = getWrappedLines(context, text, maxWidth, maxLines);
      }

      context.save();
      context.fillStyle = settings.color || '#5d5853';
      context.textAlign = settings.textAlign || 'left';
      context.textBaseline = 'alphabetic';
      lines.forEach(function (line, index) {
        context.fillText(line, x, y + fontSize + index * lineHeight);
      });
      context.restore();

      return {
        bottom: y + lines.length * lineHeight,
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: lines,
      };
    }

    function drawPillRows(context, tags, x, y, maxWidth, options) {
      var settings = options || {};
      var labels = (tags || [])
        .filter(function (tag) {
          return Boolean(tag);
        })
        .slice(0, 3);
      var gap = settings.gap || 12;
      var rowGap = settings.rowGap || 10;
      var height = settings.height || 48;
      var paddingX = settings.paddingX || 22;
      var radius = settings.radius || height / 2;
      var maxItemsPerRow = settings.maxItemsPerRow || Number.POSITIVE_INFINITY;
      var rows = [];
      var currentRow = [];
      var currentWidth = 0;

      context.save();
      context.font =
        settings.font || '700 24px CourierLocal, Courier New, monospace';

      labels.forEach(function (label) {
        var width = Math.min(
          maxWidth,
          Math.ceil(context.measureText(label).width + paddingX * 2)
        );
        var nextWidth = currentRow.length
          ? currentWidth + gap + width
          : width;

        if (
          currentRow.length &&
          (nextWidth > maxWidth || currentRow.length >= maxItemsPerRow)
        ) {
          rows.push({
            items: currentRow,
            width: currentWidth,
          });
          currentRow = [];
          currentWidth = 0;
        }

        currentRow.push({
          label: label,
          width: width,
        });
        currentWidth = currentWidth ? currentWidth + gap + width : width;
      });

      if (currentRow.length) {
        rows.push({
          items: currentRow,
          width: currentWidth,
        });
      }

      context.textAlign = 'center';
      context.textBaseline = 'middle';
      rows.forEach(function (row, rowIndex) {
        var cursorX = x + Math.max(0, (maxWidth - row.width) / 2);
        var rowY = y + rowIndex * (height + rowGap);

        row.items.forEach(function (item) {
          roundedRectPath(context, cursorX, rowY, item.width, height, radius);
          context.fillStyle = settings.fill || '#2f4960';
          context.fill();
          context.fillStyle = settings.color || '#fff';
          context.fillText(
            item.label,
            cursorX + item.width / 2,
            rowY + height / 2 + 1
          );
          cursorX += item.width + gap;
        });
      });
      context.restore();

      return y + rows.length * height + Math.max(0, rows.length - 1) * rowGap;
    }

    function createVerticalShareImage() {
      if (!lastResult || !document.createElement) {
        return Promise.resolve(null);
      }

      var result = lastResult;
      var coreAssets = resultAssets[result.coreId] || {};
      var hiddenAssets = resultAssets[result.hiddenId] || {};
      var coreProps = Array.isArray(coreAssets.props)
        ? coreAssets.props
        : [];
      var hasHidden = Boolean(
        result.hiddenId && result.hidden && result.hidden.name
      );
      var fontReady = document.fonts
        ? Promise.all([
            document.fonts.ready.catch(function () {}),
            document.fonts
              .load('400 84px Niconne')
              .catch(function () {}),
            document.fonts
              .load('400 40px Poppins')
              .catch(function () {}),
            document.fonts
              .load('700 96px Poppins')
              .catch(function () {}),
            document.fonts
              .load('700 40px CourierLocal')
              .catch(function () {}),
          ])
        : Promise.resolve();

      return Promise.all([
        fontReady,
        loadCanvasImage(
          coreAssets.backgroundMobile || coreAssets.backgroundDesktop
        ),
        loadCanvasImage(resultPaperMobileUrl),
        loadCanvasImage(coreAssets.portrait),
        loadCanvasImage(coreAssets.character || coreAssets.portrait),
        loadCanvasImage(coreAssets.modalBackground),
        loadCanvasImage(coreProps[0]),
        loadCanvasImage(hiddenAssets.avatar),
      ]).then(function (values) {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext && canvas.getContext('2d');
        if (!context) return null;

        canvas.width = 1080;
        canvas.height = Math.round((1688 / 780) * canvas.width);
        var designScale = canvas.width / 780;
        var scaleValue = function (value) {
          return value * designScale;
        };
        var scaleFont = function (value) {
          return Math.round(scaleValue(value));
        };
        var background = values[1];
        var paper = values[2];
        var portrait = values[3];
        var character = values[4];
        var cardTexture = values[5];
        var corePropOne = values[6];
        var hiddenAvatar = values[7];
        var accent = result.core.accent || '#782626';
        var backdrop = result.core.backdrop || '#2b2535';
        var hiddenAccent =
          (result.hidden && result.hidden.accent) || accent;
        var cardX = scaleValue(60);
        var cardY = scaleValue(179);
        var cardWidth = scaleValue(660);
        var cardHeight = scaleValue(1032);
        var matchX = scaleValue(60);
        var matchY = scaleValue(1231);
        var matchWidth = scaleValue(660);
        var matchHeight = scaleValue(330);
        var characterX = scaleValue(500);
        var characterY = scaleValue(387);
        var characterRight = scaleValue(770);
        var characterWidth = characterRight - characterX;
        var characterHeight = scaleValue(586);

        context.fillStyle = backdrop;
        context.fillRect(0, 0, canvas.width, canvas.height);
        drawCover(context, background, 0, 0, canvas.width, canvas.height);

        context.save();
        context.fillStyle = '#fff';
        setFittedCanvasFont(
          context,
          "You're most like",
          scaleValue(660),
          scaleFont(75),
          scaleFont(68),
          '700 {size}px Poppins, Arial, sans-serif'
        );
        context.shadowColor = 'rgba(0, 0, 0, .24)';
        context.shadowBlur = scaleValue(4);
        context.shadowOffsetY = scaleValue(2);
        context.fillText(
          "You're most like",
          scaleValue(59),
          scaleValue(105)
        );
        context.restore();

        context.save();
        context.shadowColor = 'rgba(20, 14, 10, .22)';
        context.shadowBlur = scaleValue(16);
        context.shadowOffsetY = scaleValue(6);
        roundedRectPath(
          context,
          cardX,
          cardY,
          cardWidth,
          cardHeight,
          scaleValue(16)
        );
        context.fillStyle = '#f8f7f3';
        context.fill();
        context.restore();

        context.save();
        roundedRectPath(
          context,
          cardX,
          cardY,
          cardWidth,
          cardHeight,
          scaleValue(16)
        );
        context.clip();
        context.fillStyle = '#f8f7f3';
        context.fillRect(cardX, cardY, cardWidth, cardHeight);
        if (paper) {
          context.drawImage(paper, cardX, cardY, cardWidth, cardHeight);
        }
        context.restore();

        context.save();
        context.strokeStyle = '#17120c';
        context.lineWidth = scaleValue(2);
        context.beginPath();
        context.moveTo(scaleValue(268), scaleValue(218));
        context.lineTo(scaleValue(690), scaleValue(218));
        context.stroke();
        context.lineWidth = scaleValue(1.5);
        context.beginPath();
        context.moveTo(scaleValue(268), scaleValue(226));
        context.lineTo(scaleValue(690), scaleValue(226));
        context.stroke();
        context.restore();

        context.save();
        context.fillStyle = '#17120c';
        setFittedCanvasFont(
          context,
          result.core.name,
          scaleValue(360),
          scaleFont(60),
          scaleFont(48),
          '400 {size}px Niconne, cursive'
        );
        context.textAlign = 'center';
        context.translate(scaleValue(483), 0);
        context.scale(.87, 1);
        context.fillText(
          result.core.name,
          0,
          scaleValue(304)
        );
        context.restore();

        drawPillRows(
          context,
          result.core.tags,
          scaleValue(300),
          scaleValue(337),
          scaleValue(360),
          {
            fill: accent,
            color: '#fff',
            font:
              '700 ' +
              scaleFont(24) +
              'px CourierLocal, Courier New, monospace',
            height: scaleValue(52),
            paddingX: scaleValue(18),
            gap: scaleValue(9),
            rowGap: scaleValue(18),
            maxItemsPerRow: 2,
          }
        );

        context.save();
        context.fillStyle = '#17120c';
        context.font =
          '700 ' +
          scaleFont(28) +
          'px CourierLocal, Courier New, monospace';
        context.fillText(
          'Your Core Type:',
          scaleValue(111),
          scaleValue(509)
        );
        context.restore();

        drawFittedWrappedText(
          context,
          result.core.core,
          scaleValue(111),
          scaleValue(531),
          scaleValue(381),
          scaleValue(362),
          {
            maxFontSize: scaleFont(29),
            minFontSize: scaleFont(22),
            lineHeightRatio: 1.25,
            color: '#686868',
          }
        );

        drawVisibleContain(
          context,
          character,
          characterX,
          characterY,
          characterWidth,
          characterHeight
        );

        if (hasHidden) {
          context.save();
          context.fillStyle = '#17120c';
          context.font =
            '700 ' +
            scaleFont(28) +
            'px CourierLocal, Courier New, monospace';
          context.fillText(
            'Your Hidden Type:',
            scaleValue(111),
            scaleValue(953)
          );
          context.restore();

          drawFittedWrappedText(
            context,
            result.hidden.hidden,
            scaleValue(111),
            scaleValue(978),
            scaleValue(552),
            scaleValue(180),
            {
              maxFontSize: scaleFont(27),
              minFontSize: scaleFont(21),
              lineHeightRatio: 1.25,
              color: '#686868',
            }
          );
        }

        drawContain(
          context,
          portrait,
          scaleValue(28),
          scaleValue(144),
          scaleValue(266),
          scaleValue(311)
        );

        if (hasHidden) {
          context.save();
          context.shadowColor = 'rgba(20, 14, 10, .22)';
          context.shadowBlur = scaleValue(14);
          context.shadowOffsetY = scaleValue(5);
          roundedRectPath(
            context,
            matchX,
            matchY,
            matchWidth,
            matchHeight,
            scaleValue(16)
          );
          context.fillStyle = accent;
          context.fill();
          context.restore();

          context.save();
          roundedRectPath(
            context,
            matchX,
            matchY,
            matchWidth,
            matchHeight,
            scaleValue(16)
          );
          context.clip();
          context.fillStyle = accent;
          context.fillRect(matchX, matchY, matchWidth, matchHeight);
          if (cardTexture) {
            drawCover(
              context,
              cardTexture,
              matchX,
              matchY,
              matchWidth,
              matchHeight
            );
          }
          context.restore();

          context.save();
          roundedRectPath(
            context,
            matchX,
            matchY,
            matchWidth,
            matchHeight,
            scaleValue(16)
          );
          context.clip();
          drawContain(
            context,
            hiddenAvatar,
            scaleValue(49),
            scaleValue(1232),
            scaleValue(246),
            scaleValue(327)
          );
          context.restore();

          context.save();
          context.fillStyle = '#fffaf1';
          context.font =
            '700 ' +
            scaleFont(24) +
            'px CourierLocal, Courier New, monospace';
          context.fillText(
            'Vibe Match:',
            scaleValue(291),
            scaleValue(1294)
          );
          setFittedCanvasFont(
            context,
            result.hidden.name,
            scaleValue(340),
            scaleFont(56),
            scaleFont(44),
            '400 {size}px Niconne, cursive'
          );
          context.translate(scaleValue(291), 0);
          context.scale(.8, 1);
          context.fillText(
            result.hidden.name,
            0,
            scaleValue(1365)
          );
          context.restore();

          drawPillRows(
            context,
            result.hidden.tags,
            scaleValue(290),
            scaleValue(1388),
            scaleValue(351),
            {
              fill: hiddenAccent,
              color: '#fff',
              font:
                '700 ' +
                scaleFont(24) +
                'px CourierLocal, Courier New, monospace',
              height: scaleValue(52),
              paddingX: scaleValue(20),
              gap: scaleValue(10),
              rowGap: scaleValue(18),
              maxItemsPerRow: 2,
            }
          );
        }

        drawContain(
          context,
          corePropOne,
          scaleValue(579),
          scaleValue(1147),
          scaleValue(129),
          scaleValue(170)
        );

        context.save();
        context.fillStyle = '#fff';
        context.textAlign = 'center';
        context.shadowColor = 'rgba(0, 0, 0, .32)';
        context.shadowBlur = scaleValue(5);
        context.shadowOffsetY = scaleValue(2);
        context.font =
          '400 ' + scaleFont(26) + 'px Poppins, Arial, sans-serif';
        context.fillText(
          'Discover your craft personality at',
          scaleValue(390),
          scaleValue(1611)
        );
        context.fillText(
          'robotimeonline.com',
          scaleValue(390),
          scaleValue(1643)
        );
        context.restore();

        return new Promise(function (resolve) {
          if (typeof canvas.toBlob !== 'function') {
            resolve(null);
            return;
          }

          try {
            canvas.toBlob(
              function (blob) {
                if (!blob) {
                  resolve(null);
                  return;
                }

                if (typeof window.File === 'function') {
                  resolve(
                    new window.File(
                      [blob],
                      'craft-ti-' + result.coreId + '-result.png',
                      { type: 'image/png' }
                    )
                  );
                  return;
                }

                blob.name = 'craft-ti-' + result.coreId + '-result.png';
                resolve(blob);
              },
              'image/png',
              1
            );
          } catch (error) {
            resolve(null);
          }
        });
      });
    }

    function prepareShareImage() {
      if (!lastResult) return Promise.resolve(null);

      var resultKey = [lastResult.coreId, lastResult.hiddenId || ''].join('|');
      if (shareImageFile && shareImageResultKey === resultKey) {
        setImageShareButtonsReady(true);
        return Promise.resolve(shareImageFile);
      }
      if (shareImagePromise && shareImageResultKey === resultKey) {
        return shareImagePromise;
      }

      shareImageResultKey = resultKey;
      shareImageFile = null;
      setImageShareButtonsReady(false);
      setShareFeedback('preparing', 'Preparing your vertical result card…');

      var currentPromise = createVerticalShareImage()
        .then(function (file) {
          if (shareImageResultKey !== resultKey) return null;
          shareImageFile = file;
          setImageShareButtonsReady(true);
          setShareFeedback(
            file ? 'ready' : 'warning',
            file
              ? 'Your vertical result card is ready to share.'
              : 'Image sharing is unavailable in this browser. Your caption and quiz link are still ready.'
          );
          return file;
        })
        .catch(function () {
          if (shareImageResultKey !== resultKey) return null;
          setImageShareButtonsReady(true);
          setShareFeedback(
            'warning',
            'Image sharing is unavailable in this browser. Your caption and quiz link are still ready.'
          );
          return null;
        })
        .finally(function () {
          if (shareImagePromise === currentPromise) {
            shareImagePromise = null;
          }
        });

      shareImagePromise = currentPromise;
      return currentPromise;
    }

    function getShareData() {
      var resultLabel = lastResult ? lastResult.core.name : 'CRAFT-TI';
      var resultUrl = new URL(window.location.href);
      resultUrl.search = '';
      resultUrl.hash = '';
      if (lastResult) {
        resultUrl.searchParams.set('result', lastResult.coreId);
        if (resultEmailEligible) {
          resultUrl.searchParams.set('hidden', lastResult.hiddenId);
        } else {
          resultUrl.searchParams.delete('hidden');
        }
      }
      return {
        title: 'My CRAFT-TI result: ' + resultLabel,
        text: getShareCaption(resultUrl.toString()),
        url: resultUrl.toString(),
      };
    }

    function syncSocialShareLinks() {
      var shareData = getShareData();

      socialShareLinks.forEach(function (link) {
        var channel = link.dataset.ctiShareChannel;

        if (channel === 'facebook') {
          link.href =
            'https://www.facebook.com/sharer/sharer.php?u=' +
            encodeURIComponent(shareData.url) +
            '&quote=' +
            encodeURIComponent(shareData.text);
          return;
        }

        if (channel === 'x') {
          link.href =
            'https://twitter.com/intent/tweet?text=' +
            encodeURIComponent(shareData.text);
          return;
        }

        if (channel === 'pinterest') {
          var coreAssets = lastResult
            ? resultAssets[lastResult.coreId] || {}
            : {};
          var communityImageUrl = String(
            coreAssets.communityImage || ''
          ).trim();
          link.href =
            'https://www.pinterest.com/pin/create/button/?url=' +
            encodeURIComponent(shareData.url) +
            (communityImageUrl
              ? '&media=' + encodeURIComponent(communityImageUrl)
              : '') +
            '&description=' +
            encodeURIComponent(shareData.text);
          return;
        }

        if (channel === 'reddit') {
          link.href =
            'https://www.reddit.com/submit?url=' +
            encodeURIComponent(shareData.url) +
            '&title=' +
            encodeURIComponent(shareData.text);
        }
      });
    }

    function copyResultLink(message) {
      var shareData = getShareData();
      var copyMessage = getShareCaption(shareData.url, '\n\n');

      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        showCopyFeedback(
          'error',
          'Couldn’t copy the link. Please select it and copy it manually.'
        );
        return Promise.resolve(false);
      }

      return navigator.clipboard
        .writeText(copyMessage)
        .then(function () {
          showCopyFeedback('success', '');
          announce(message || 'Result message and link copied.');
          return true;
        })
        .catch(function () {
          showCopyFeedback(
            'error',
            'Couldn’t copy the link. Please select it and copy it manually.'
          );
          return false;
        });
    }

    function copyShareMessage() {
      var shareData = getShareData();
      var message = shareData.text;

      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        return Promise.resolve(false);
      }

      return navigator.clipboard
        .writeText(message)
        .then(function () {
          return true;
        })
        .catch(function () {
          return false;
        });
    }

    function copyFacebookCaption() {
      var shareData = getShareData();

      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        announce(
          'Opening Facebook. Add your CRAFT-TI result caption manually.'
        );
        return;
      }

      navigator.clipboard
        .writeText(shareData.text)
        .then(function () {
          announce(
            'Facebook caption copied. Paste it into your Facebook post.'
          );
        })
        .catch(function () {
          announce(
            'Opening Facebook. Add your CRAFT-TI result caption manually.'
          );
        });
    }

    function downloadShareImage(file) {
      if (!file || !window.URL || !window.URL.createObjectURL) return false;

      var downloadUrl = window.URL.createObjectURL(file);
      var link = document.createElement('a');
      link.href = downloadUrl;
      link.download =
        file.name ||
        'craft-ti-' +
          (lastResult ? lastResult.coreId : 'result') +
          '-result.png';
      link.hidden = true;
      document.body.appendChild(link);
      link.click();
      link.remove();
      addTimeout(function () {
        window.URL.revokeObjectURL(downloadUrl);
      }, 1000);
      return true;
    }

    function fallbackVerticalShare() {
      var downloaded = downloadShareImage(shareImageFile);
      copyShareMessage().then(function (copied) {
        var message =
          downloaded && copied
            ? 'Vertical result card downloaded and caption copied — upload both to another app.'
            : downloaded
              ? 'Vertical result card downloaded. Copy the result link below for your caption.'
              : copied
                ? 'Caption and quiz link copied. Add them to your post.'
                : 'Use the result link below to share your result.';
        setShareFeedback(downloaded || copied ? 'success' : 'error', message);
        announce(message);
      });
    }

    function shareVerticalResult() {
      var shareData = getShareData();
      var filePayload = shareImageFile ? { files: [shareImageFile] } : null;
      var canShareFile = false;
      if (filePayload && navigator.share && navigator.canShare) {
        try {
          canShareFile = navigator.canShare(filePayload);
        } catch (error) {
          canShareFile = false;
        }
      }

      if (canShareFile) {
        var nativeShareData = {
          title: shareData.title,
          text: shareData.text,
          files: [shareImageFile],
        };

        try {
          navigator
            .share(nativeShareData)
            .then(function () {
              setShareFeedback('success', 'Vertical result card shared.');
              announce('Vertical result card shared.');
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              fallbackVerticalShare();
            });
          return;
        } catch (error) {
          fallbackVerticalShare();
          return;
        }
      }

      if (navigator.share) {
        try {
          navigator
            .share({
              title: shareData.title,
              text: shareData.text,
            })
            .then(function () {
              setShareFeedback('success', 'Result and quiz link shared.');
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              fallbackVerticalShare();
            });
          return;
        } catch (error) {
          fallbackVerticalShare();
          return;
        }
      }

      fallbackVerticalShare();
    }

    function resetCopyFeedback() {
      if (copyFeedbackTimeoutId !== null) {
        window.clearTimeout(copyFeedbackTimeoutId);
        timeouts.delete(copyFeedbackTimeoutId);
        copyFeedbackTimeoutId = null;
      }
      if (copyFeedback) {
        copyFeedback.textContent = '';
        copyFeedback.removeAttribute('data-state');
      }
      if (copyField) {
        copyField.removeAttribute('data-copy-state');
      }
      if (copyLinkButton) {
        copyLinkButton.classList.remove('is-copied');
        copyLinkButton.setAttribute('aria-label', 'Copy result link');
      }
    }

    function showCopyFeedback(state, message) {
      resetCopyFeedback();
      if (copyFeedback) {
        copyFeedback.textContent = message;
        copyFeedback.dataset.state = state;
      } else {
        announce(message);
      }
      if (copyField) {
        copyField.dataset.copyState = state;
      }
      if (copyLinkButton && state === 'success') {
        copyLinkButton.classList.add('is-copied');
        copyLinkButton.setAttribute('aria-label', 'Result link copied');
      }
      copyFeedbackTimeoutId = addTimeout(function () {
        copyFeedbackTimeoutId = null;
        if (copyFeedback) {
          copyFeedback.textContent = '';
          copyFeedback.removeAttribute('data-state');
        }
        if (copyField) {
          copyField.removeAttribute('data-copy-state');
        }
        if (copyLinkButton) {
          copyLinkButton.classList.remove('is-copied');
          copyLinkButton.setAttribute('aria-label', 'Copy result link');
        }
      }, 3000);
    }

    function closeResultModal(restoreFocus) {
      if (!resultScene || !modalLayer) return;
      if (modalFocusFrameId !== null) {
        window.cancelAnimationFrame(modalFocusFrameId);
        modalFocusFrameId = null;
      }
      resultScene.classList.remove('modal-open', 'show-share-modal', 'show-save-modal');
      root.classList.remove('has-open-result-modal');
      modalLayer.setAttribute('aria-hidden', 'true');
      activeResultDialog = null;
      resetCopyFeedback();

      if (restoreFocus !== false && lastModalTrigger) {
        lastModalTrigger.focus({ preventScroll: true });
      }
      lastModalTrigger = null;
    }

    function openResultModal(type, trigger) {
      if (!resultScene || !modalLayer) return;
      resetCopyFeedback();
      lastModalTrigger = trigger || null;
      resultScene.classList.add('modal-open');
      root.classList.add('has-open-result-modal');
      resultScene.classList.toggle('show-share-modal', type === 'share');
      resultScene.classList.toggle('show-save-modal', type === 'save');
      modalLayer.setAttribute('aria-hidden', 'false');

      if (copyUrl) {
        var shareUrl = new URL(getShareData().url);
        copyUrl.textContent =
          (shareUrl.host || 'rolifeonline.com') +
          shareUrl.pathname +
          shareUrl.search;
      }
      if (type === 'share') {
        syncSocialShareLinks();
        syncCommunityShareLink();
        prepareShareImage();
      }

      var dialog = resultScene.querySelector(type === 'share' ? '.share-modal' : '.save-modal');
      if (dialog) {
        activeResultDialog = dialog;
        if (modalFocusFrameId !== null) {
          window.cancelAnimationFrame(modalFocusFrameId);
        }
        modalFocusFrameId = window.requestAnimationFrame(function () {
          modalFocusFrameId = null;
          if (activeResultDialog !== dialog) return;
          var focusTarget =
            type === 'save' &&
            saveEmailInput &&
            resultEmailEligible &&
            (!saveEmailForm || saveEmailForm.dataset.state !== 'success')
              ? saveEmailInput
              : dialog;
          focusTarget.focus({ preventScroll: true });
        });
      }

      if (type === 'save') {
        if (!resultEmailEligible) {
          setSaveEmailState('ineligible');
        } else {
          var currentSaveState = saveEmailForm
            ? saveEmailForm.dataset.state
            : '';
          if (!currentSaveState) {
            resetSaveEmailState();
          }
        }
      }
    }

    function startNewTest() {
      trackAnalytics(
        'craft_ti_new_test',
        Object.assign(
          {
            previous_question_number: currentQuestionIndex + 1,
            previous_completed: completionTracked,
          },
          getResultAnalyticsData()
        )
      );
      resultLoadToken += 1;
      transitioning = false;
      answers = {};
      currentQuestionIndex = 0;
      lastResult = null;
      resultEmailEligible = true;
      saveEmailPostedSuccessfully = false;
      saveEmailHasErrors = false;
      saveEmailServerStateRestored = false;
      shareImageFile = null;
      shareImagePromise = null;
      shareImageResultKey = '';
      quizRunId = createAnalyticsId('run');
      quizStartedAt = 0;
      analyticsSequence = 0;
      trackedAnswerSignatures = {};
      completionTracked = false;
      entryMode = 'quiz';

      closeResultModal(false);
      resetSaveEmailState();
      if (saveEmailInput) saveEmailInput.value = '';
      if (saveEmailTags) saveEmailTags.value = 'craft-ti';

      mailboxStage.classList.remove('is-letter-ready', 'is-letter-open');
      lampStage.classList.remove('is-lamp-open');
      quizStage.classList.remove(
        'quiz-live',
        'show-result',
        'is-result-loading'
      );
      root.removeAttribute('data-cti-result-type');
      root.removeAttribute('data-cti-hidden-type');
      renderQuestion(false);

      try {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.search = '';
        cleanUrl.hash = '';
        window.history.replaceState(
          window.history.state,
          '',
          cleanUrl.toString()
        );
      } catch (error) {}

      showStep(1, true);
      root.scrollIntoView({
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
        block: 'start',
      });
      addTimeout(function () {
        startTrigger.focus({ preventScroll: true });
      }, reducedMotion.matches ? 20 : 260);
      announce('A new CRAFT-TI test is ready. Open the letter to begin.');
    }

    listen(shareButton, 'click', function (event) {
      event.preventDefault();
      trackAnalytics(
        'craft_ti_share_opened',
        getResultAnalyticsData()
      );
      openResultModal('share', shareButton);
    });

    listen(saveButton, 'click', function (event) {
      event.preventDefault();
      openResultModal('save', saveButton);
    });

    listen(newTestButton, 'click', startNewTest);

    asArray(root.querySelectorAll('[data-cti-close-modal]')).forEach(function (button) {
      listen(button, 'click', function () {
        closeResultModal(true);
      });
    });

    listen(modalLayer, 'click', function (event) {
      if (event.target === modalLayer) {
        closeResultModal(true);
      }
    });

    listen(root, 'keydown', function (event) {
      if (
        !resultScene ||
        !resultScene.classList.contains('modal-open') ||
        !activeResultDialog
      ) {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        closeResultModal(true);
        return;
      }

      if (event.key === 'Tab') {
        var focusable = asArray(
          activeResultDialog.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])'
          )
        ).filter(function (element) {
          return (
            !element.hidden &&
            element.getAttribute('aria-hidden') !== 'true' &&
            element.getClientRects().length > 0
          );
        });

        if (!focusable.length) {
          event.preventDefault();
          activeResultDialog.focus({ preventScroll: true });
          return;
        }

        var firstFocusable = focusable[0];
        var lastFocusable = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === firstFocusable) {
          event.preventDefault();
          lastFocusable.focus({ preventScroll: true });
        } else if (!event.shiftKey && document.activeElement === lastFocusable) {
          event.preventDefault();
          firstFocusable.focus({ preventScroll: true });
        } else if (!activeResultDialog.contains(document.activeElement)) {
          event.preventDefault();
          firstFocusable.focus({ preventScroll: true });
        }
      }
    });

    listen(copyLinkButton, 'click', function () {
      trackAnalytics(
        'craft_ti_share_clicked',
        Object.assign({ share_channel: 'copy_link' }, getResultAnalyticsData())
      );
      copyResultLink();
    });

    listen(instagramShareButton, 'click', function () {
      trackAnalytics(
        'craft_ti_share_clicked',
        Object.assign({ share_channel: 'instagram' }, getResultAnalyticsData())
      );
      shareVerticalResult();
    });

    listen(facebookShareLink, 'click', function () {
      trackAnalytics(
        'craft_ti_share_clicked',
        Object.assign({ share_channel: 'facebook' }, getResultAnalyticsData())
      );
      copyFacebookCaption();
    });

    listen(xShareLink, 'click', function () {
      trackAnalytics(
        'craft_ti_share_clicked',
        Object.assign({ share_channel: 'x' }, getResultAnalyticsData())
      );
    });

    listen(pinterestShareLink, 'click', function () {
      trackAnalytics(
        'craft_ti_share_clicked',
        Object.assign({ share_channel: 'pinterest' }, getResultAnalyticsData())
      );
    });

    listen(redditShareLink, 'click', function () {
      trackAnalytics(
        'craft_ti_share_clicked',
        Object.assign({ share_channel: 'reddit' }, getResultAnalyticsData())
      );
    });

    listen(moreShareButton, 'click', function () {
      trackAnalytics(
        'craft_ti_share_clicked',
        Object.assign({ share_channel: 'more' }, getResultAnalyticsData())
      );
      shareVerticalResult();
    });

    listen(communityShareLink, 'click', function () {
      trackAnalytics(
        'craft_ti_community_clicked',
        getResultAnalyticsData()
      );
      announce('Opening a pre-filled Robotime Community post.');
    });

    function setSaveEmailState(state) {
      var isBusy = state === 'confirming';
      var isIneligible = state === 'ineligible';
      if (saveEmailForm) {
        saveEmailForm.dataset.state = state;
        saveEmailForm.setAttribute('aria-busy', isBusy ? 'true' : 'false');
        saveEmailForm.hidden = state === 'success';
      }
      if (saveEmailHeading) {
        saveEmailHeading.textContent =
          state === 'success' ? 'Results on the way!' : 'Save Your Results';
      }
      if (saveEmailIntro) saveEmailIntro.hidden = state === 'success';
      if (saveEmailSuccess) saveEmailSuccess.hidden = state !== 'success';
      if (saveEmailError) saveEmailError.hidden = state !== 'error';
      if (saveEmailInput) {
        saveEmailInput.readOnly = isBusy || isIneligible || state === 'success';
        saveEmailInput.setAttribute(
          'aria-disabled',
          isBusy || isIneligible || state === 'success' ? 'true' : 'false'
        );
      }
      if (saveEmailButton) {
        var isButtonDisabled =
          isBusy || isIneligible || state === 'success';
        saveEmailButton.disabled = isButtonDisabled;
        saveEmailButton.setAttribute(
          'aria-disabled',
          isButtonDisabled ? 'true' : 'false'
        );
      }
      if (saveEmailButtonLabel) {
        var buttonLabel = 'Confirm';
        if (state === 'confirming') buttonLabel = 'Confirming...';
        saveEmailButtonLabel.textContent = buttonLabel;
      }
    }

    function resetSaveEmailState() {
      setSaveEmailState('idle');
    }

    function getResultSubscriptionTags() {
      var tags = ['craft-ti'];
      if (!lastResult || !resultEmailEligible) return tags;

      tags.push('craft-ti-core-' + lastResult.coreId);
      return tags;
    }

    function clearSaveEmailResponseUrl() {
      try {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('customer_posted');
        cleanUrl.searchParams.delete('contact_posted');
        cleanUrl.hash = '';
        window.history.replaceState(
          window.history.state,
          '',
          cleanUrl.pathname + cleanUrl.search
        );
      } catch (error) {}
    }

    function restoreSaveEmailServerState() {
      if (
        saveEmailServerStateRestored ||
        (!saveEmailPostedSuccessfully && !saveEmailHasErrors)
      ) {
        return;
      }
      saveEmailServerStateRestored = true;

      if (saveEmailPostedSuccessfully) {
        setSaveEmailState('success');
        trackAnalytics(
          'craft_ti_email_subscribed',
          getResultAnalyticsData()
        );
        announce(
          'Success. Your results will be sent to your email within 1-2 minutes.'
        );
      } else {
        setSaveEmailState('error');
        announce('We could not confirm your subscription. Please try again.');
      }

      openResultModal('save', null);
      clearSaveEmailResponseUrl();
    }

    listen(saveEmailForm, 'submit', function (event) {
      if (
        !saveEmailInput ||
        !saveEmailButton ||
        !lastResult ||
        !resultEmailEligible ||
        saveEmailForm.dataset.state === 'confirming' ||
        saveEmailForm.dataset.state === 'success'
      ) {
        event.preventDefault();
        return;
      }

      if (!saveEmailInput.checkValidity()) {
        event.preventDefault();
        saveEmailInput.reportValidity();
        return;
      }

      saveEmailInput.value = saveEmailInput.value.trim().toLowerCase();
      if (saveEmailTags) {
        saveEmailTags.value = getResultSubscriptionTags().join(',');
      }
      if (saveEmailReturnTo) {
        var resultReturnUrl = new URL(getShareData().url);
        saveEmailReturnTo.value =
          resultReturnUrl.pathname + resultReturnUrl.search;
      }
      setSaveEmailState('confirming');
      saveEmailInput.blur();
    });

    listen(saveEmailInput, 'input', function () {
      if (
        !saveEmailForm ||
        saveEmailForm.dataset.state === 'confirming'
      ) {
        return;
      }
      resetSaveEmailState();
    });

    renderQuestion(false);

    if (reducedMotion.matches) {
      markLetterReady();
    } else {
      addTimeout(markLetterReady, 5200);
    }

    var parameters = new URLSearchParams(window.location.search);
    if (parameters.has('result')) {
      var requestedResultId = parameters.get('result');
      var hasValidRequestedResult = Object.prototype.hasOwnProperty.call(
        quizData.personalities,
        requestedResultId
      );
      if (hasValidRequestedResult) {
        entryMode = 'shared_result';
        var previewHiddenId = getFixedHiddenPersonalityId(requestedResultId);
        var hasValidFixedHidden = Boolean(previewHiddenId);
        var previewHidden = hasValidFixedHidden
          ? quizData.personalities[previewHiddenId]
          : {
              name: 'Unavailable',
              hidden:
                'This result does not have a configured hidden type. Retake the test to reveal and email your complete result.',
            };

        if (hasValidFixedHidden && parameters.get('hidden') !== previewHiddenId) {
          try {
            var normalizedResultUrl = new URL(window.location.href);
            normalizedResultUrl.searchParams.set('hidden', previewHiddenId);
            window.history.replaceState(
              window.history.state,
              '',
              normalizedResultUrl.toString()
            );
          } catch (error) {}
        }

        var sharedResultLoadToken = ++resultLoadToken;
        quizStage.classList.add('is-result-loading');
        var sharedResultReady = renderResult({
          coreId: requestedResultId,
          hiddenId: hasValidFixedHidden ? previewHiddenId : '',
          core: quizData.personalities[requestedResultId],
          hidden: previewHidden,
          scores: {},
          styleChoice: null,
          emailEligible: hasValidFixedHidden,
        });
        showStep(3, false);
        var shouldRestoreSaveEmailState =
          saveEmailPostedSuccessfully || saveEmailHasErrors;
        if (shouldRestoreSaveEmailState) {
          revealResult(sharedResultLoadToken, false);
          restoreSaveEmailServerState();
        }
        sharedResultReady.then(function () {
          if (!shouldRestoreSaveEmailState) {
            revealResult(sharedResultLoadToken, false);
          }
          trackAnalytics(
            'craft_ti_result_viewed',
            Object.assign(
              { result_source: 'shared_link' },
              getResultAnalyticsData()
            )
          );
          if (!shouldRestoreSaveEmailState) {
            restoreSaveEmailServerState();
          }
        });
      } else {
        showStep(1, false);
        preloadStep(2);
      }
    } else {
      showStep(1, false);
      preloadStep(2);
    }

    syncPageClass();

    controllers.set(root, {
      destroy: function () {
        if (modalFocusFrameId !== null) {
          window.cancelAnimationFrame(modalFocusFrameId);
          modalFocusFrameId = null;
        }
        cleanups.forEach(function (cleanup) {
          cleanup();
        });
        timeouts.forEach(function (timeoutId) {
          window.clearTimeout(timeoutId);
        });
        timeouts.clear();
        controllers.delete(root);
        syncPageClass(root);
      },
    });
  }

  function refresh() {
    getRoots().forEach(initCraftTiTest);
    syncPageClass();
  }

  function unload(root) {
    var controller = controllers.get(root);
    if (controller) controller.destroy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-cti-test]');
    if (root) initCraftTiTest(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-cti-test]');
    if (root) unload(root);
  });

  window.CraftTiTest = {
    refresh: refresh,
  };
})();
